module.exports = __webpack_public_path__ + "fa-brands-400.ab673bac3a9e36cb1d4e.ttf";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-brands-400.ttf
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-brands-400.ttf
// module chunks = styles